<template>
  <v-dialog scrollable content-class="custom-dialog" ref="dlgPengimbasan" v-model="dialog" retain-focus max-width="700">
    <template v-slot:activator="{}"></template>

    <v-card v-if="jenis">
      <v-card-title class="primary title white--text">Unggah Video Pengimbasan</v-card-title>
      <v-card-text>
        <div class="pa-3" v-html="jenis.agreement"></div>
        <v-row row wrap justify="center" align="center">
          <v-col cols="12" sm="12" md="12" lg="12" xl="12">
            <v-form autocomplete="false" @submit.prevent data-vv-scope="form" lazy-validation>
              <v-card flat class="pa-5 mb-5">
                <v-card-text>
                  <v-row wrap>
                    <v-col cols="12" class="py-0">
                      <v-text-field
                        outlined
                        dense
                        autofocus
                        prepend-inner-icon="mdi-youtube"
                        autocomplete="false"
                        name="Tautan"
                        placeholder="Letakkan tautan pengimbasan Anda pada form berikut"
                        label="Tautan Video Pengimbasan"
                        v-model="pengimbasan.url"
                        hint="Tombol kirim akan aktif jika tautan video yang Anda masukkan sudah benar"
                        persistent-hint
                        data-vv-name="nama"
                        data-vv-as="Tautan video pengimbasan"
                        v-validate="{ url: { require_protocol: true }, required: true }"
                        :error-messages="errors.collect('form.nama')"
                      >
                      </v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <span class="black--text">Contoh penulisan tautan yang benar: </span>
                      <p class="blue--text my-0 py-0">https://www.youtube.com/watch?v=xaeda</p>
                      <p class="blue--text my-0 py-0">https://www.youtu.be.com/F4AZe</p>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-form>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions class="pb-4">
        <v-spacer></v-spacer>
        <m-button
          class="mx-1"
          :disabled="is_disable"
          :small="$vuetify.breakpoint.smAndDown ? true : false"
          textButton="Unggah"
          icon=""
          action="pilihKelas"
          @pilihKelas="daftarKelas()"
        ></m-button>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  $_veeValidate: {
    validator: "new"
  },
  data() {
    return {
      jenis: null,
      items: [],
      edit: false,
      dialog: false,
      resolve: null,
      reject: null,
      idJenis: null,
      kelasObject: {},
      pengimbasan: {
        url: ""
      },
      is_disable: true,
      defKelas: {
        nama: ""
      }
    };
  },
  methods: {
    // eslint-disable-next-line
    open(obj, showCourses, idJenis) {
      this.jenis = obj;
      this.idJenis = idJenis;
      this.showCourses = showCourses;

      return this.loadJadwal(obj, idJenis).then(() => {
        return new Promise((resolve, reject) => {
          this.resolve = resolve;
          this.reject = reject;
          this.dialog = true;
        });
      });
    },
    // eslint-disable-next-line
    loadJadwal(obj, idJenis) {
      return this.$store
        .dispatch("kelas/getJadwalPerJenis", {
          instansi_id: this.instansi_id,
          jenis_id: idJenis,
          obj: obj
        })
        .then(res => {
          var tempKelas = [];

          res.forEach(diklat => {
            diklat.kelas.forEach(kelas => {
              tempKelas.push(kelas);
            });
          });
          if (tempKelas.length) {
            this.kelas = tempKelas[0].id;
          }
          this.items = [...tempKelas];
        })
        .catch(e => e);
    },
    daftarKelas() {
      this.$validator
        .validateAll("form")
        .then(res => {
          if (!res) return Promise.reject();
          return res;
        })
        .then(() => {
          this.pengimbasan.kelas_id = this.items[0].id;
          return this.$store
            .dispatch("kelas/inputVideoPengimbasan", {
              instansi_id: this.instansi_id,
              obj: this.pengimbasan
            })
            .then(res => {
              if (res) {
                this.$info("Unggah tautan video berhasil");
                this.dialog = false;
                return this.resolve(res);
              }
            })
            .catch(e => e);
        })
        .catch(e => e);
    }
  },
  watch: {
    dialog(n) {
      if (!n && this.reject) {
        this.reject(null);
      }
    },
    "pengimbasan.url"(n) {
      var match_1 = n.match(/.youtube.*/);
      var match_2 = n.match(/.youtu.be.*/);

      if (match_1) {
        this.is_disable = false;
      } else if (match_2) {
        this.is_disable = false;
      } else {
        this.is_disable = true;
      }
    }
  },
  computed: {}
};
</script>
